import {
  NOT_COIN_CLAIM_AVAILABLE_LS_KEY,
  RECHARGE_DROP_IS_AVAILABLE_LS_KEY,
  NOT_COIN_CLAIM_DONE_LS_KEY,
  RECHARGE_DROP_DONE_LS_KEY,
} from '../constants'
import { ClaimRewardAvailableLsKey, ClaimRewardDoneLsKey } from '../type'

const isClaimAvailable = (
  availableLsKey: ClaimRewardAvailableLsKey,
  claimedLsKey: ClaimRewardDoneLsKey
) => {
  return !(
    localStorage.getItem(claimedLsKey) || !localStorage.getItem(availableLsKey)
  )
}

export const isNotCoinClaimAvailable = () => {
  return isClaimAvailable(
    NOT_COIN_CLAIM_AVAILABLE_LS_KEY,
    NOT_COIN_CLAIM_DONE_LS_KEY
  )
}

export const isRechargeDropAvailable = () => {
  return isClaimAvailable(
    RECHARGE_DROP_IS_AVAILABLE_LS_KEY,
    RECHARGE_DROP_DONE_LS_KEY
  )
}
